/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const providerNameEnumSchema = z
	.enum(["MCRM", "SMS_RU", "IIKO", "RedSMS", "SMS_C"])
	.describe("* `MCRM` - MCRM\n* `SMS_RU` - SMS_RU\n* `IIKO` - iiko\n* `RedSMS` - RedSMS\n* `SMS_C` - SMS_C");
